import { FormikContextTypeEnhanced } from '@superdispatch/forms';
import { FormikValues } from 'formik';
import { ReactNode } from 'react';
import { FormikDrawerContent } from 'shared/form/FormikDrawer';
import { MobileDrawerFormLayout } from '../../../profile/superpay/MobileDrawerFormContent';

interface MobileDrawerLayoutProps {
  formik: FormikContextTypeEnhanced<FormikValues, unknown>;
  title: ReactNode;
  action: ReactNode;
  children: ReactNode;
  enableBack?: boolean;
  onBack?: () => void;
}

export function MobileDrawerLayout({
  formik,
  title,
  action,
  children,
  enableBack,
  onBack,
}: MobileDrawerLayoutProps) {
  return (
    <MobileDrawerFormLayout action={action}>
      <FormikDrawerContent
        formik={formik}
        title={title}
        enableBack={enableBack}
        onBack={onBack}
        disableClose={true}
        disableAutoClose={true}
        disableNavigationBlock={true}
        actions={null}
      >
        {children}
      </FormikDrawerContent>
    </MobileDrawerFormLayout>
  );
}
